/**
 * Ключи в localStorage для auth-state.
 *
 * Один источник правды — чтобы `http.ts` и `atoms/auth/` не разъезжались.
 * Менять только здесь.
 */

export const TOKEN_STORAGE_KEY = 'kassir:auth:token';
export const USER_STORAGE_KEY = 'kassir:auth:user';
export const PERMISSION_STORAGE_KEY = 'kassir:auth:permission';
